"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _ChevronLeft = _interopRequireDefault(require("@mui/icons-material/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@mui/icons-material/ChevronRight"));
var _VerticalTabsModule = _interopRequireDefault(require("./VerticalTabs.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ToggleMenu = _ref => {
  let {
    isOpen,
    setIsOpen
  } = _ref;
  if (isOpen) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _VerticalTabsModule.default.toolbar
    }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
      onClick: () => setIsOpen(false)
    }, /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
      className: _VerticalTabsModule.default.chevronIcon
    })));
  }
  return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "inherit",
    "aria-label": "open drawer",
    onClick: () => setIsOpen(true),
    edge: "start",
    className: (0, _clsx.default)(_VerticalTabsModule.default.menuButton)
  }, /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
    className: _VerticalTabsModule.default.chevronIcon
  }));
};
var _default = exports.default = ToggleMenu;